import { zip } from "app/utils/helpers";
import PropTypes from "prop-types";
import { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";

const LegendItem = ({ legendCss, textCss, label, background }) => (
  <div className={`${legendCss} flex flex-row`}>
    <div className="flex flex-col justify-start">
      <div
        className="inline-block h-[12px] w-[12px] rounded-full ltr:mr-3 
        rtl:ml-3"
        style={{
          backgroundColor: background,
        }}
      ></div>
    </div>
    <div className="flex flex-1 flex-col xl:justify-center">
      <div className={textCss}>{label}</div>
    </div>
  </div>
);

// NOTE: This custom Doughnut is intended to be used
// if we want more than one doughnut graph with
// legends while maintaining a constant width.
// It is not possible out of the box with the
// legend API that "chart.js" provides.

export const DoughnutWithLegend = ({
  data = {},
  options = {},
  legendCss,
  textCss,
}) => {
  const labels = useMemo(() => data.labels, [data]);
  const backgrounds = useMemo(
    () => data.datasets[0]?.backgroundColor || [],
    [data]
  );
  const legendData = useMemo(
    () =>
      zip(labels, backgrounds).map(([label, background], index) => (
        <LegendItem
          key={index}
          legendCss={legendCss}
          textCss={textCss}
          label={label}
          background={background}
        />
      )),
    [labels, backgrounds, legendCss, textCss]
  );

  return (
    <div className="flex h-full w-full flex-row justify-center">
      <div className="flex flex-col xl:flex-row">
        <div className="flex flex-row justify-center">
          <div className="w-[170px] lg:w-[180px]">
            <figure>
              <Doughnut data={data} options={options} />
            </figure>
          </div>
        </div>
        <div
          className="mt-16 flex flex-1 flex-col justify-start xl:mt-0 
          xl:justify-center"
        >
          <div
            className="legend-data grid min-w-[330px] grid-cols-2 gap-x-2.5
            xl:block xl:min-w-full"
          >
            {legendData}
          </div>
        </div>
      </div>
    </div>
  );
};

DoughnutWithLegend.propTypes = {
  data: PropTypes.object,
  options: PropTypes.object,
  legendCss: PropTypes.string,
  textCss: PropTypes.string,
};
